import {
  CaracterizacaoActions,
  CaracterizacaoActionTypes,
} from '../actions/caracterizacao.actions';
import { CARACTERIZACAO_INIT_TABLE } from '../mock';
import { Caracterizacao } from '../types/caracterizacao.types';

export interface CaracterizacaoState {
  data: Caracterizacao | null;
  loading: boolean;
  error: string | null;
  tableList: typeof CARACTERIZACAO_INIT_TABLE;
}

export const initialState: CaracterizacaoState = {
  data: null,
  loading: false,
  error: null,
  tableList: CARACTERIZACAO_INIT_TABLE,
};

export function reducer(
  state = initialState,
  action: CaracterizacaoActions
): CaracterizacaoState {
  switch (action.type) {
    case CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_TABLE:
      return { ...state, loading: false, tableList: action.payload };

    case CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case CaracterizacaoActionTypes.LOAD_CARACTERIZACAO_CLEAR:
      return initialState;
    default:
      return state;
  }
}

export const selectData = (state: CaracterizacaoState) => state.data;
